// import React, { useState, useRef, useEffect, useContext } from "react";
// import { Carousel, Button, Modal } from "antd";
// import { FaHeart } from "react-icons/fa"; // Import FontAwesome Heart icon
// import { useHistory } from "react-router-dom";
// import arrowleft from "./Images/arrowleft.png";
// import arrowright from "./Images/arrowright.png";
// import axios from "axios";
// import ArrowDown from "./Images/ArrowDown.png";
// import CloseImg from "./Images/CloseImg.png";
// import Rating from "@mui/material/Rating";
// import shoppingbag from "./Images/shoppingbag.png";
// import { AppContext, useAppContext } from "./AppContext";
// import { styled } from "@mui/material/styles";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
// import PerfumeBlockTwoCards from "./PerfumeBlockComponents/PerfumeBlockTwoCards";
// import LottifileLoading from "./LottifileLoading.json";
// import Lottie from "lottie-react";
// import { useTranslation } from "react-i18next";
// import donemakeapp2 from "./donemakeapp2.json";

// import { format } from "date-fns";
// import CreditCardImage from "./Images/CreditCardImage.png";
// import DiscoverLogoImage from "./Images/DiscoverLogoImage.png";
// import JCBLogoImage from "./Images/JCBLogoImage.png";
// import VisaLogoImage from "./Images/VisaLogoImage.png";
// import AmericanExpressLogoImage from "./Images/AmericanExpressLogoImage.png";
// import MasterCardLogoImage from "./Images/MasterCardLogoImage.png";
// import DinersClubLogoImage from "./Images/DinersClubLogoImage.png";
// import UnlockImage from "./Images/UnlockImage.png";
// import dollarImage from "./Images/dollarImage.png";

// export const MyDomain = "https://localhost:44326/";
// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   "& .MuiDialogContent-root": {
//     padding: theme.spacing(2),
//   },
//   "& .MuiDialogActions-root": {
//     padding: theme.spacing(1),
//   },
//   "& .MuiPaper-root": {
//     width:
//       window.innerWidth <= 1920
//         ? "90%"
//         : window.innerWidth <= 2560
//         ? "70%"
//         : window.innerWidth <= 3840
//         ? "60%"
//         : "50%", // Full width minus 5% padding on each side
//     margin: "0 auto", // Center the modal horizontally
//     maxWidth: "none", // Disable the default max width
//     borderRadius: 0,
//   },
// }));
// const BootstrapDialogDone = styled(Dialog)(({ theme }) => ({
//   "& .MuiDialogContent-root": {
//     padding: theme.spacing(2),
//   },
//   "& .MuiDialogActions-root": {
//     padding: theme.spacing(1),
//   },
//   "& .MuiPaper-root": {
//     width:
//       window.innerWidth <= 1024
//         ? "80%"
//         : window.innerWidth <= 1440
//         ? "50%"
//         : window.innerWidth <= 1920
//         ? "30%"
//         : window.innerWidth <= 2560
//         ? "50%"
//         : window.innerWidth <= 3840
//         ? "60%"
//         : "50%", // Full width minus 5% padding on each side
//     margin: "0 auto", // Center the modal horizontally
//     maxWidth: "none", // Disable the default max width
//     borderRadius: 0,
//   },
// }));

// export default function BeautyClub() {
//   const [openDone, setOpenDone] = useState(false);
//   const handleClose2 = async () => {
//     setOpenDone(false);
//   };

//   function ModalDone() {
//     return (
//       <div>
//         <React.Fragment>
//           <BootstrapDialogDone
//             onClose={handleClose2}
//             aria-labelledby="customized-dialog-title"
//             open={openDone}
//             fullWidth
//             maxWidth={false} // Disable Material-UI's default width settings
//           >
//             <DialogTitle
//               sx={{ m: 0, p: 2 }}
//               id="customized-dialog-title"
//             ></DialogTitle>
//             <IconButton
//               aria-label="close"
//               onClick={handleClose2}
//               sx={(theme) => ({
//                 position: "absolute",
//                 right: 8,
//                 top: 8,
//                 color: theme.palette.grey[500],
//               })}
//             >
//               <CloseIcon />
//             </IconButton>
//             <div
//               style={{
//                 width: "100%",
//                 display: "flex",
//                 flexDirection: "row",
//               }}
//             >
//               <div
//                 style={{
//                   width: "100%",
//                   height: "calc(50vh - 55px)",
//                   padding: 20,
//                   //backgroundColor: "red",
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     width: "100%",
//                     justifyContent: "center",
//                     marginBottom: 20,
//                   }}
//                 >
//                   {/* <a
//                     style={{
//                       fontSize: 20,
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {t("profile.Chooselanguage")}
//                   </a> */}
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <p
//                     style={{
//                       margin: 5,
//                       padding: 0,
//                       fontSize: 18,
//                       cursor: "pointer",
//                       // color: Lang === "en" ? "black" : "#a1a1aa",
//                       // fontWeight: Lang === "en" ? "bold" : "",
//                     }}
//                     onClick={() => {}}
//                   >
//                     {t("profile.areyousureyouwantcancelsubscription")}
//                   </p>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     width: "100%",
//                     justifyContent: "space-around",
//                   }}
//                 >
//                   <button
//                     style={{
//                       marginTop: 20,
//                       backgroundColor: "#27272a",
//                       color: "#fff",
//                       border: "none",
//                       //padding: "10px 20px",
//                       cursor: "pointer",
//                       fontSize: "16px",
//                       width: "45%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       height: 50,
//                       marginTop: 40,
//                     }}
//                     onClick={async () => {
//                       await DeleteBeautyClub();
//                       await handleClose2();
//                     }}
//                   >
//                     <a style={{ fontSize: 14 }}>{t("profile.Yes")}</a>
//                   </button>
//                   <button
//                     style={{
//                       marginTop: 20,
//                       backgroundColor: "#27272a",
//                       color: "#fff",
//                       border: "none",
//                       //padding: "10px 20px",
//                       cursor: "pointer",
//                       fontSize: "16px",
//                       width: "45%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       height: 50,
//                       marginTop: 40,
//                     }}
//                     onClick={async () => {
//                       //await DeleteBeautyClub();

//                       await handleClose2();
//                     }}
//                   >
//                     <a style={{ fontSize: 14 }}>{t("profile.No")}</a>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </BootstrapDialogDone>
//         </React.Fragment>
//       </div>
//     );
//   }
//   const { User, Token } = useAppContext();

//   const [MyWidth, setMyWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setMyWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     // Cleanup listener on unmount
//     return () => window.removeEventListener("resize", handleResize);
//   }, [MyWidth]);

//   const user = JSON.parse(localStorage.getItem("user"));

//   const [loading1, setLoading1] = useState(true);
//   const [error1, setError1] = useState(null);
//   const [UserExistInBeautyClub, setUserExistInBeautyClub] = useState(false);
//   const [error2, setError2] = useState(false);

//   const fetchData = async () => {
//     console.log("aa");
//     if (!User || !Token) {
//       setError1("User or Token is missing");
//       setLoading1(false);
//       return;
//     }
//     try {
//       const response = await axios.get(
//         `https://localhost:44326/BeautyClub/GetUserDatafromBeautyClub?UserId=${user?.userId}`,
//         {
//           // headers: {
//           //   Authorization: `Bearer ${Token}`,
//           // },
//           params: { Id: User.userId },
//         }
//       );
//       setUserExistInBeautyClub(true);
//       console.log(response.data);
//       setLoading1(false);
//     } catch (err) {
//       setUserExistInBeautyClub(false);
//       console.log(err.response.data);
//       setError1(err.response.data);
//       setLoading1(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);
//   const { t, i18n } = useTranslation();
//   const [open, setOpen] = useState(false);

//   const handleClose = () => {
//     setOpen(false);
//   };
//   const [cardType, setcardType] = useState("");
//   const [CVV, setCVV] = useState("");
//   const [NameCardHolder, setNameCardHolder] = useState("");
//   const [PAYLoading, setPAYLoading] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [ResponseErrorMSG, setResponseErrorMSG] = useState("");

//   //
//   const handleChangeNameCardHolder = (e) => {
//     const value = e.target.value;
//     setNameCardHolder(value);
//   };
//   const handleChangeCVV = (e) => {
//     const value = e.target.value;
//     setCVV(value);
//   };
//   const [isValid, setIsValid] = useState(false);
//   const prevExpiryRef = useRef("");
//   const handleChangeExpirtyDate = (e) => {
//     let value = e.target.value;

//     // Remove any non-digit characters except slash
//     value = value.replace(/[^\d/]/g, "");

//     // Check if user is deleting (compare with previous value)
//     const isDeleting = value.length < prevExpiryRef.current.length;

//     // Auto-insert slash after 2 digits (only when typing, not deleting)
//     if (
//       !isDeleting &&
//       value.length === 2 &&
//       ExpirtyDate.length <= value.length
//     ) {
//       value = value + "/";
//     }

//     // Remove slash if it's in the wrong position when deleting
//     if (isDeleting && value.length === 3 && value[2] === "/") {
//       value = value.substring(0, 2);
//     }

//     // Limit to 5 characters (MM/YY)
//     if (value.length > 5) {
//       value = value.substring(0, 5);
//     }

//     setExpirtyDate(value);
//     prevExpiryRef.current = value;

//     // Validate MM/YY format
//     const mmYYPattern = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
//     setIsValid(mmYYPattern.test(value) || value.length === 0);
//   };
//   const [cardNumber, setCardNumber] = useState("");
//   const [ExpirtyDate, setExpirtyDate] = useState("");

//   const detectCardType = (number) => {
//     if (/^4/.test(number)) return "visa";
//     if (
//       /^5[1-5]/.test(number) ||
//       /^22[2-9]/.test(number) ||
//       /^2[3-7]/.test(number)
//     )
//       return "mastercard";
//     if (/^3[47]/.test(number)) return "amex";
//     if (
//       /^65/.test(number) ||
//       /^6011/.test(number) ||
//       /^64[4-9]/.test(number) ||
//       /^622(12[6-9]|1[3-9][0-9]|2[0-5][0-9]|[6-9][0-9]{2})/.test(number)
//     )
//       return "discover";
//     if (/^3(?:0[0-5]|[68])/.test(number)) return "dinersclub";
//     if (/^35[2-8]/.test(number)) return "jcb";
//     return null;
//   };
//   const [CardType, setCardType] = useState("");
//   const formatCardNumber = (value) => {
//     let numericValue = value.replace(/\D/g, "").slice(0, 16);
//     return numericValue.replace(/(\d{4})/g, "$1 ").trim();
//   };
//   const handleChange = (e) => {
//     const value = e.target.value;
//     const formattedNumber = formatCardNumber(value);
//     setCardNumber(formattedNumber);
//     // Detect the card type
//     setCardType(detectCardType(value.replace(/\s/g, "")));
//   };
//   // Select the correct card logo
//   const getCardLogo = () => {
//     switch (cardType) {
//       case "visa":
//         return VisaLogoImage;
//       case "mastercard":
//         return MasterCardLogoImage;
//       case "amex":
//         return AmericanExpressLogoImage;
//       case "discover":
//         return DiscoverLogoImage;
//       case "dinersclub":
//         return DinersClubLogoImage;
//       case "jcb":
//         return JCBLogoImage;
//       default:
//         return CreditCardImage; // Default card icon
//     }
//   };
//   const CreateOrder = async () => {
//     console.log(user?.userId);
//     if (!User || !Token) {
//       setError("User or Token is missing");
//       return;
//     }
//     setPAYLoading(true);
//     const today = new Date();
//     const formattedDate = format(today, "MM-dd-yyyy");
//     const now = new Date();
//     const formattedTime = format(now, "HH:mm");
//     const data = {
//       UserId: user?.userId,
//       SubscribeStatus: 1,
//       DateSubs: formattedDate,
//       TimeSubs: formattedTime,
//       ThePlan: 1,
//       Discount: 10,
//     };
//     try {
//       const response = await axios.post(
//         `${MyDomain}BeautyClub/SubscribeBeautyClub`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${Token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       setPAYLoading(false);
//       console.log(response.data);
//       setOpen(true);
//       setResponseErrorMSG("");
//       setUserExistInBeautyClub(true);
//       setOpen2(true);
//       // Set it back to false after 5 seconds
//       setTimeout(() => {
//         setOpen2(false);
//         setOpen(false);

//         //history.push(`/`);
//       }, 4000);
//     } catch (err) {
//       setPAYLoading(false);
//       console.log(err.response.data);
//       setResponseErrorMSG(err.response.data);
//     }
//   };

//   const DeleteBeautyClub = async () => {
//     const data = {
//       userId: user?.userId,
//     };
//     try {
//       const response = await axios.delete(
//         "https://localhost:44326/BeautyClub/UnSubscribeBeautyClub",
//         {
//           data: { UserId: user?.userId },
//         }
//       );
//       console.log(response.data);
//       setUserExistInBeautyClub(false);
//       window.location.reload();
//       //GetAddresses();
//       //setOpen1(false);
//       //setMessage('Item deleted successfully');
//     } catch (err) {
//       console.log(err.response.data);
//     }
//   };
//   const [open2, setOpen2] = useState(false);

//   const MyModal2 = () => {
//     return (
//       <>
//         <React.Fragment>
//           <BootstrapDialogDone
//             //onClose={handleClose2}
//             aria-labelledby="customized-dialog-title"
//             open={open2}
//             fullWidth
//             maxWidth={false} // Disable Material-UI's default width settings
//           >
//             <DialogTitle
//               sx={{ m: 0, p: 2 }}
//               id="customized-dialog-title"
//             ></DialogTitle>

//             <div style={{}}>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "row",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "35%",
//                     height: "calc(75vh - 55px)",
//                     paddingTop: "1%",
//                     paddingBottom: "1%",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <div
//                     style={{
//                       justifyContent: "center",
//                       display: "flex",
//                       alignItems: "center",
//                       width: "100%",
//                     }}
//                   >
//                     <Lottie
//                       //style={{ height: 40, width: 40 }}
//                       animationData={donemakeapp2}
//                     />
//                   </div>
//                   <a style={{ fontSize: 20 }}>
//                     {t("profile.thedealsuccessfullydone")}
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </BootstrapDialogDone>
//         </React.Fragment>
//       </>
//     );
//   };
//   const MyModal = () => {
//     return (
//       <>
//         <React.Fragment>
//           {/* <Button variant="outlined" onClick={handleClickOpen}>
//               Open dialog
//             </Button> */}
//           <BootstrapDialog
//             onClose={handleClose}
//             aria-labelledby="customized-dialog-title"
//             open={open}
//             fullWidth
//             maxWidth={false} // Disable Material-UI's default width settings
//           >
//             <DialogTitle
//               sx={{ m: 0, p: 2 }}
//               id="customized-dialog-title"
//             ></DialogTitle>
//             <IconButton
//               aria-label="close"
//               onClick={handleClose}
//               sx={(theme) => ({
//                 position: "absolute",
//                 right: 8,
//                 top: 8,
//                 color: theme.palette.grey[500],
//               })}
//             >
//               <CloseIcon />
//             </IconButton>
//             <div style={{}}>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "row",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     //width: "55%",
//                     height: "calc(75vh - 55px)",
//                     display: "flex",
//                     //backgroundColor: "red",
//                     paddingTop: "1%",
//                     paddingBottom: "1%",
//                     flexDirection: "column",
//                     direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//                   }}
//                 >
//                   {/* <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns:
//                         MyWidth <= 1024 ? "repeat(1, 1fr)" : "repeat(3, 1fr)", // Exactly 3 items per row

//                       //gap: "10px",
//                       height: "80%",
//                     }}
//                   ></div> */}
//                   <div
//                     style={{
//                       height: "20%",
//                       width: "100%",
//                       display: "flex",
//                       //justifyContent: "flex-end",
//                       //alignItems: "center",
//                       flexDirection: "column",
//                     }}
//                   >
//                     {/* <p style={{ margin: 0 }}>
//                         {" "}
//                         ₪{OBJOfProductChoosed.price}&nbsp; &nbsp;
//                       </p> */}
//                     <a
//                       style={{
//                         fontWeight: "500",
//                         fontSize: 16,
//                         paddingBottom: 5,
//                         display: "flex",
//                       }}
//                     >
//                       {t("profile.CreditorDebitCardNumber")}
//                     </a>
//                     <div style={{ position: "relative", width: "100%" }}>
//                       {/* Card Logo on the Left */}
//                       <img
//                         src={getCardLogo()}
//                         alt="Card Type"
//                         style={{
//                           width: 30,
//                           height: 30,
//                           position: "absolute",
//                           left: 10,
//                           top: "50%",
//                           transform: "translateY(-50%)",
//                           opacity: cardType === null ? 0.5 : 1,
//                         }}
//                       />
//                       {/* ✅ Inline Style for Placeholder */}
//                       <style>
//                         {`
//                                 input::placeholder {
//                                   color: #d4d4d8;
//                                 }
//                               `}
//                       </style>

//                       {/* Input Field */}
//                       <input
//                         type="text"
//                         value={cardNumber}
//                         onChange={handleChange}
//                         placeholder="XXXX XXXX XXXX XXXX"
//                         style={{
//                           width: "100%",
//                           height: 50,
//                           border: "1px solid #a1a1aa",
//                           padding: "5px 10px 5px 55px", // Adjusted padding for left icon space
//                           borderRadius: "10px",
//                           outline: "none",
//                           fontSize: "16px",
//                           letterSpacing: "2px",
//                         }}
//                         maxLength="19"
//                       />
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         flexDirection: "row",
//                         justifyContent: "space-between",
//                         width: "100%",
//                         paddingTop: 20,
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           width: "48%",
//                         }}
//                       >
//                         <a
//                           style={{
//                             fontWeight: "500",
//                             fontSize: 16,
//                             paddingBottom: 5,
//                             display: "flex",
//                           }}
//                         >
//                           {t("profile.ExpiryDate")}
//                         </a>
//                         <input
//                           type="text"
//                           value={ExpirtyDate}
//                           onChange={handleChangeExpirtyDate}
//                           placeholder={t("profile.MMYY")}
//                           style={{
//                             width: "100%",
//                             height: 50,
//                             border: "1px solid #a1a1aa",
//                             padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
//                             borderRadius: "10px",
//                             outline: "none",
//                             fontSize: "16px",
//                             letterSpacing: "2px",
//                           }}
//                           maxLength="5"
//                         />
//                         {/* {!isValid && ExpirtyDate.length > 0 && (
//                                   <p style={{ color: "red" }}>Please enter a valid MM/YY format</p>
//                                 )} */}
//                       </div>
//                       <div
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           width: "48%",
//                         }}
//                       >
//                         <a
//                           style={{
//                             fontWeight: "500",
//                             fontSize: 16,
//                             paddingBottom: 5,
//                             display: "flex",
//                           }}
//                         >
//                           CVV/CVC*
//                         </a>
//                         <input
//                           type="text"
//                           value={CVV}
//                           onChange={handleChangeCVV}
//                           placeholder="CVV"
//                           style={{
//                             width: "100%",
//                             height: 50,
//                             border: "1px solid #a1a1aa",
//                             padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
//                             borderRadius: "10px",
//                             outline: "none",
//                             fontSize: "16px",
//                             letterSpacing: "2px",
//                           }}
//                           maxLength="4"
//                         />
//                       </div>
//                     </div>
//                     <div
//                       style={{
//                         paddingTop: 20,
//                       }}
//                     >
//                       <a
//                         style={{
//                           fontWeight: "500",
//                           fontSize: 16,
//                           paddingBottom: 5,
//                           display: "flex",
//                         }}
//                       >
//                         {t("profile.Nameoncard")}
//                       </a>
//                       <div style={{ position: "relative", width: "100%" }}>
//                         {/* ✅ Inline Style for Placeholder */}
//                         <style>
//                           {`
//                                 input::placeholder {
//                                   color: #d4d4d8;
//                                 }
//                               `}
//                         </style>

//                         {/* Input Field */}
//                         <input
//                           type="text"
//                           value={NameCardHolder}
//                           onChange={handleChangeNameCardHolder}
//                           placeholder={t("profile.Fullnameasoncard")}
//                           style={{
//                             width: "100%",
//                             height: 50,
//                             border: "1px solid #a1a1aa",
//                             padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
//                             borderRadius: "10px",
//                             outline: "none",
//                             fontSize: "16px",
//                             letterSpacing: "2px",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                           }}
//                           //maxLength="19"
//                         />
//                         <div
//                           style={{
//                             display: "flex",
//                             width: "100%",
//                             justifyContent: "center",
//                             marginTop: 20,
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <button
//                             style={{
//                               backgroundColor: "#27272a",
//                               color: "#fff",
//                               border: "none",
//                               padding: "10px 20px",
//                               cursor: "pointer",
//                               fontSize: "16px",
//                               width: 300,
//                               height: 50,
//                               opacity: PAYLoading === false ? 1 : 0.5, // Optional: make it look disabled
//                               cursor:
//                                 PAYLoading === false
//                                   ? "pointer"
//                                   : "not-allowed",
//                             }}
//                             disabled={PAYLoading !== false}
//                             onClick={() => {
//                               CreateOrder();
//                             }}
//                           >
//                             <img
//                               src={UnlockImage}
//                               alt="Card Type"
//                               style={{
//                                 width: 20,
//                                 height: 20,
//                                 color: "white",
//                                 filter: "invert(100%) brightness(100%)", // Converts the image to white
//                               }}
//                             />
//                             &nbsp;&nbsp;
//                             {PAYLoading ? (
//                               <>
//                                 <Lottie
//                                   style={{ height: 30, width: 30 }}
//                                   animationData={LottifileLoading}
//                                 />
//                               </>
//                             ) : (
//                               <>
//                                 <a
//                                   style={{
//                                     fontSize: 18,
//                                     fontWeight: "500",
//                                   }}
//                                 >
//                                   {t("profile.Subscribe")}
//                                 </a>
//                               </>
//                             )}
//                           </button>
//                           {ResponseErrorMSG === "" ? (
//                             <></>
//                           ) : (
//                             <>
//                               <a style={{ fontSize: 14, color: "red" }}>
//                                 {ResponseErrorMSG}
//                               </a>
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </BootstrapDialog>
//         </React.Fragment>
//       </>
//     );
//   };
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         marginTop: 50,
//         marginLeft: MyWidth <= 1024 ? "2%" : "0%",
//         marginRight: MyWidth <= 1024 ? "2%" : "0%",
//       }}
//     >
//       {MyModal()}
//       {MyModal2()}
//       {ModalDone()}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginBottom: 50,
//         }}
//       >
//         <a style={{ fontSize: 25, fontWeight: "bold" }}>
//           Lemaq store Beauty Club
//         </a>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           marginBottom: 30,
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a>
//           {t("BeautyClub.Welcometo")}{" "}
//           <a style={{ fontSize: 18, fontWeight: "bold" }}>Lemaq store</a>,{" "}
//           {t("BeautyClub.wherebeautymeetssmartshopping")}
//           <br></br> {t("BeautyClub.Nowyoucanunlock")}
//           <br></br> {t("BeautyClub.subscriptiondesignedformakeup")}
//         </a>
//       </div>
//       <div
//         style={{
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a style={{ fontSize: 18 }}>
//           💋 {t("BeautyClub.WhyJointhe")}{" "}
//           <a style={{ fontSize: 18, fontWeight: "bold" }}>
//             Lemaq store Beauty Club
//           </a>{" "}
//           ?
//         </a>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           marginTop: 30,
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a style={{ marginBottom: 10 }}>
//           🌟 <a style={{ fontWeight: "bold" }}>10%</a>{" "}
//           {t("BeautyClub.OFFeverysingle")}
//         </a>
//         <a style={{ marginBottom: 10 }}>
//           💸 {t("BeautyClub.The")} <a style={{ fontWeight: "bold" }}>10%</a>{" "}
//           {t("BeautyClub.OFFalsocomebeside")}
//         </a>
//         <a style={{ marginBottom: 10 }}>
//           🎁 {t("BeautyClub.Monthlysurprises")}
//         </a>
//         <a style={{ marginBottom: 10 }}>
//           🚚 {t("BeautyClub.Freeexpressshipping")}
//         </a>
//         <a style={{ marginBottom: 10 }}>
//           💄 {t("BeautyClub.Membersonlydeals")}
//         </a>
//         <a style={{ marginBottom: 10 }}>
//           ⛔ {t("BeautyClub.Cancelanytimenolongtermcommitments")}
//         </a>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           marginTop: 30,
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a>🛍 {t("BeautyClub.RealExample")}:</a>
//         <a>
//           <a style={{ fontSize: 16, fontWeight: "bold" }}>Lemaq store</a>{" "}
//           {t("BeautyClub.MatteLipstick")}
//         </a>
//         <a>{t("BeautyClub.Nonmember")}</a>
//         <a>{t("BeautyClub.BeautyClubMember")}</a>
//         <a>
//           <a style={{ fontSize: 16, fontWeight: "bold" }}>Lemaq store</a>{" "}
//           {t("BeautyClub.SkincareSet")}
//         </a>
//         <a>{t("BeautyClub.Nonmember250")}</a>
//         <a>{t("BeautyClub.BeautyClubMember225")}</a>
//         <a>
//           {t("BeautyClub.Justtwoitemscan")}{" "}
//           <a style={{ fontWeight: "bold" }}>{t("BeautyClub.saveyou35")}</a>{" "}
//           {t("BeautyClub.inoneorderalone")}
//         </a>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           marginTop: 30,
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a>🧠 {t("BeautyClub.FrequentlyAskedQuestions")}</a>
//         <a>{t("BeautyClub.WhathappensafterIsubscribe")}</a>
//         <a>
//           {t("BeautyClub.Youllinstantlyunlockyour")}{" "}
//           <a style={{ fontWeight: "bold" }}>10%</a>{" "}
//           {t("BeautyClub.discountandperks")}
//         </a>
//         <a>{t("BeautyClub.CanIcancelanytime")}</a>
//         <a>{t("BeautyClub.YesYoucancancelyour")}</a>
//         <a>{t("BeautyClub.Whatpaymentmethodsdoyousupport")}</a>

//         <a>{t("BeautyClub.Weacceptallmajor")}</a>
//         <a>{t("BeautyClub.DoIneedtocommitforawholeyear")}</a>
//         <a>{t("BeautyClub.NopeItsmonthlyStartorstopwheneveryoulike")}</a>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           marginTop: 30,
//           direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
//         }}
//       >
//         <a>✨ {t("BeautyClub.ReadytoSaveonEveryOrder")}</a>
//         <a>{t("BeautyClub.Jointhousandsofhappy")}</a>
//         <a>👉 {t("BeautyClub.JoinBeautyClubStartSaving")}</a>
//         <a>{t("BeautyClub.OnlymonthCancelAnytimeOffEverything")}</a>
//         {/* <a>💌 Already a member?</a>
//         <a>[Log In to Get Your Discounts]</a> */}
//       </div>

//       {user === null ? (
//         <>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               flexDirection: "column",
//               marginTop: 50,
//               alignItems: "center",
//             }}
//           >
//             <button
//               style={{
//                 backgroundColor: "#27272a",
//                 color: "#fff",
//                 border: "none",
//                 padding: "10px 20px",
//                 cursor: "pointer",
//                 fontSize: "16px",
//                 width: 300,
//                 height: 50,
//               }}
//               onClick={() => {
//                 if (user === null) {
//                   console.log("pleas login first to sub");
//                   setError2(true);
//                 } else {
//                   setOpen(true);
//                 }
//               }}
//             >
//               <a>{t("BeautyClub.SUBSCRIBENOW")}</a>
//             </button>
//             {error2 === false ? (
//               <></>
//             ) : (
//               <>
//                 <a style={{ fontSize: 14, color: "red" }}>
//                   {t("BeautyClub.Pleaseloginfirst")}
//                 </a>
//               </>
//             )}
//           </div>
//         </>
//       ) : (
//         <>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               flexDirection: "column",
//               marginTop: 50,
//               alignItems: "center",
//             }}
//           >
//             {UserExistInBeautyClub ? (
//               <>
//                 {/* <a>you are subs</a> */}
//                 <button
//                   style={{
//                     backgroundColor: "#27272a",
//                     color: "#fff",
//                     border: "none",
//                     padding: "10px 20px",
//                     cursor: "pointer",
//                     fontSize: "16px",
//                     width: 300,
//                     height: 50,
//                   }}
//                   onClick={() => {
//                     setOpenDone(true);
//                   }}
//                 >
//                   <a>{t("BeautyClub.CANCELSUBSCRIBE")}</a>
//                 </button>
//               </>
//             ) : (
//               <>
//                 {" "}
//                 <button
//                   style={{
//                     backgroundColor: "#27272a",
//                     color: "#fff",
//                     border: "none",
//                     padding: "10px 20px",
//                     cursor: "pointer",
//                     fontSize: "16px",
//                     width: 300,
//                     height: 50,
//                   }}
//                   onClick={() => {
//                     if (user === null) {
//                       console.log("pleas login first to sub");
//                       setError2(true);
//                     } else {
//                       setOpen(true);
//                     }
//                   }}
//                 >
//                   <a>{t("BeautyClub.SUBSCRIBENOW")}</a>
//                 </button>
//                 {error2 === false ? (
//                   <></>
//                 ) : (
//                   <>
//                     <a style={{ fontSize: 14, color: "red" }}>
//                       {t("BeautyClub.Pleaseloginfirst")}
//                     </a>
//                   </>
//                 )}
//               </>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

import React from "react";

export default function BeautyClub() {
  return (
    <div
      style={{
        paddingTop: 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Soon !
    </div>
  );
}
